@for (pos of positions; track pos) { @if
(alertsGroupedByPosition().get(pos)?.length) {
<div [class]="'alert-container ' + pos">
  @for (alert of alertsGroupedByPosition().get(pos); track alert.id) {
  <div class="enter" [class.exit]="closingAlerts().has(alert.id)">
    <umss-alert
      [line1]="alert.title"
      [line2]="alert.description || ''"
      [showCloseButton]="true"
      [type]="alert.type"
      (onClose)="removeAlert(alert.id)"
    />
  </div>
  }
</div>
} }
